import { createReducer } from '@reduxjs/toolkit';
import { apiRequestSuccess } from 'services/api/api.actions';
import { promoCodeQueryPrams } from 'services/recharges/recharges.actions';
import { calcGatewayCircuitComposeId } from 'utils/functions/payments';
import { topupMethodsEndpoint } from './recharges.config';
import {
  DepositModeKey,
  TopupBonus,
  TopupMethod,
  TopupMethodsResponse,
} from './recharges.types';

type RechargesState = {
  topupMethods?: { [key in DepositModeKey]: TopupMethod };
  bonus: { [key: string]: TopupBonus };
  promoCode: string;
};

const initialState: RechargesState = {
  bonus: {},
  promoCode: '',
};

const rechargesReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(promoCodeQueryPrams, (state, { payload: { promoCode } }) => {
      if (promoCode) {
        state.promoCode = promoCode;
      }
    })
    .addCase(apiRequestSuccess, (state, action) => {
      const { payload } = action;

      if (payload.resourceId !== topupMethodsEndpoint) {
        return;
      }

      const response: TopupMethodsResponse = payload.response.data;

      const topupMethods = response.responseObject;

      if (!Array.isArray(topupMethods)) return;

      const topupMethodsKeyValueEntries = topupMethods.map((topupMethod) => {
        const topupCompositeId = calcGatewayCircuitComposeId(
          topupMethod.gatewayId,
          topupMethod.circuitId,
        );
        return [topupCompositeId, topupMethod];
      });

      state.topupMethods = Object.fromEntries(topupMethodsKeyValueEntries);

      const topups = response.topups;
      if (topups !== null && typeof topups === 'object') {
        state.bonus = topups;
      }
    }),
);

export default rechargesReducer;
